import {getAnalyticsSectionPathFromNavigationConfig} from '@rdcomponents/app/routing/helpers/navigation-config-path';
import {NavigationItemConfigType} from '@rdcomponents/app/routing/routing-type';

import {UserType} from '../user/user-type';

import {AnalyticsEventEnum} from './analytics-type';

function getActiveLeftMenuText(pathname: string, navigationConfig: Array<NavigationItemConfigType>): string {
    return getAnalyticsSectionPathFromNavigationConfig(pathname, navigationConfig);
}

export function pushToDataLayer(data: Record<string, unknown>): void {
    if (!Array.isArray(window.dataLayer)) {
        return;
    }

    window.dataLayer.push(data);
}

export function trackNavigationGoogleAnalytics(
    pathname: string,
    previousPathname: string,
    navigationConfig: Array<NavigationItemConfigType>
): void {
    pushToDataLayer({
        previousSectionComb: getActiveLeftMenuText(previousPathname, navigationConfig),
        sectionComb: getActiveLeftMenuText(pathname, navigationConfig),
    });
}

export function initializeGoogleAnalytics(user: UserType): void {
    // using allowlist to make sure that no personal fields are sent (email, profile)
    pushToDataLayer({
        event: AnalyticsEventEnum.RocketdataEvent,
        eventCategory: 'User Data',
        eventAction: 'User Pageview',
        eventLabel: '',
        id: user.id,
        language: user.language,
        is_staff: user.isStaff,
        is_rocketdata: !user?.isStaff && user?.email.endsWith('rocketdata.io'),
        is_test_user: user.isTestUser,
        is_demo_user: user.isDemoCpUser,
        is_double_gis_trusted: user.isDoubleGisTrusted,
    });
}
